import React, { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Grid
} from '@mui/material';
import './promptMessage.css';
import logo from '../assets/pizano-logo.png';

const PromptMessage = () => {
  const [inputValue, setInputValue] = useState('');
  const [status, setStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endDate, setEndDate] = useState('');
  const [endTime, setEndTime] = useState('');

  const handleSend = async () => {
    if (
      !inputValue.trim() ||
      !startDate.trim() ||
      !startTime.trim() ||
      !endDate.trim() ||
      !endTime.trim()
    ) {
      setStatus('Please fill in all fields before sending.');
      return;
    }

    const payload = {
      Message: inputValue,
      StartDate: startDate,
      StartTime: startTime,
      EndDate: endDate,
      EndTime: endTime,
    };

    try {
      const response = await fetch('https://darj5zwp93.execute-api.us-east-1.amazonaws.com/Dev', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setStatus('Successfully sent!');
        setInputValue('');
        setStartDate('');
        setStartTime('');
        setEndDate('');
        setEndTime('');
        setTimeout(() => {
    setStatus('');
  }, 5000);
      } else {
        const errorText = await response.text();
        setStatus(`Error: ${errorText}`);
      }
    } catch (error) {
      setStatus(`Failed to send: ${error.message}`);
    }
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh' }}
      className="prompt-container"
    >
      <Grid item xs={11} sm={8} md={6} lg={4}>
        <Card elevation={4} className="card">
          <CardContent>
            <Grid container direction="column" spacing={2} alignItems="center">
              <Grid item>
                <a
                  href="/"
                  style={{
                    backgroundColor: 'black',
                    padding: '8px',
                    borderRadius: '8px',
                    display: 'inline-block',
                  }}
                >
                  <img
                    src={logo}
                    alt="Pizano's Pizza Logo"
                    className="logo"
                  />
                </a>
              </Grid>

              <Grid item>
                <Typography
                  variant="h6"
                  align="center"
                  sx={{ fontSize: '14px', marginBottom: '-8px', fontWeight: 'bold' }}
                >
                  Prompt Message
                </Typography>
              </Grid>

              <Grid item style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Enter your message"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  className="custom-input"
                />
              </Grid>

              <Grid item style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Start Date"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  className="custom-input"
                />
              </Grid>

              <Grid item style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Start Time"
                  type="time"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  className="custom-input"
                />
              </Grid>

              <Grid item style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="End Date"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  className="custom-input"
                />
              </Grid>

              <Grid item style={{ width: '100%' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="End Time"
                  type="time"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  className="custom-input"
                />
              </Grid>

              <Grid item style={{ marginTop: '12px' }}>
                <Button variant="contained" color="primary" onClick={handleSend}>
                  Send
                </Button>
              </Grid>

              {status && (
                <Grid item>
                  <Typography
                    variant="body2"
                    style={{ color: status.toLowerCase().includes('success') ? 'green' : 'red' }}
                  >
                    {status}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default PromptMessage;
